const TRANSLATION = {
  buyModal: {
    afterFree: 'Μετά την δωρεάν δοκιμή σας',
    btn: 'Δοκιμάστε το δωρεάν',
    freeTrial: '3 Ημερών Δωρεάν δοκιμή',
    monthLabel: 'μήνας',
    selectLabel: 'Επιλέξτε ένα σχέδιο',
    title: 'Σχέδιο Συνδρομής',
    yearLabel: 'έτος',
  },
  contact: {
    block1:
      'Για προσαρμογές, ερωτήσεις ή προτάσεις, επικοινωνήστε μαζί μας στο contact@noam.tools. Θα ανταποκριθούμε άμεσα.',
    block2: 'Υποστηρίξτε μας βαθμολογώντας μας στο κατάστημα επεκτάσεων Google Apps με ★★★★★.',
    block3: 'Βοηθήστε άλλους μοιράζοντας αυτήν την επέκταση:',
    title: 'Επικοινωνήστε Μαζί Μας',
  },
  help: {
    AquickOverviewOfNoam: 'Μια Γρήγορη Επισκόπηση του Noam',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Διαχείριση Προτιμημένων',
    Fixedplugin: 'Επιδιορθωμένο Πρόσθετο',
    Focusing: 'Εστίαση',
    Free: 'Ελεύθερο',
    FreeTrialBenefits: 'Οφέλη Δωρεάν Δοκιμής',
    GoWithWikipedia: 'Μεταβείτε στην Wikipedia',
    GoWithYouTube: 'Μετάβασε στο YouTube',
    HoverTranslation: 'Μεταφρασμός Υποτροχιάς',
    Howtouse: 'Πώς να χρησιμοποιήσετε',
    ImageTranslation: 'Μετάφραση Εικόνας',
    InstantTranslation: 'Ακαριαία Μετάφραση',
    Membership: 'Μέλος',
    NoamHelp: 'Ο Noam βοηθάει σε μετάφραση και σύνοψη',
    PDFparallelTranslation: 'Παράλληλη Μετάφραση PDF',
    ParallelTranslation: 'Παράλληλη Μετάφραση',
    SkipAllSteps: 'Παράλειψη όλων των βημάτων',
    Summary: 'Σύνοψη',
    Translation: 'Μετάφραση',
    TryItForFree: 'Δοκιμάστε το δωρεάν',
    Video: 'Βίντεο',
    VideoSummary: 'Σύνοψη Βίντεο',
    VideoTranslation: 'Μετάφραση Βίντεο',
    WebSummary: 'Σύνοψη Ιστοσελίδας',
    WordSelectionTranslation: 'Μετάφραση Επιλογής Λέξεων',
    benefits: 'Έχουμε οφέλη αναμένουν για εσάς!',
    dayFree: '3-ημερήσια δωρεάν δοκιμή',
    done: 'Ολοκληρώθηκε',
    next: 'Επόμενο',
    pin: 'Καρφίστε τον Noam για ευκολότερη πρόσβαση～～',
    planIsNotExist: 'Το σχέδιο δεν είναι διαθέσιμο',
    startWiki: 'Ας ξεκινήσουμε με τη Wikimedia!',
    startYoutube: 'Ας ξεκινήσουμε με το YouTube!',
    try: 'Δοκιμάστε το',
    tryNow: 'Δοκιμάστε το τώρα!',
  },
  home: {
    PDFTranslate: {
      desc: 'Δίγλωσση Μετάφραση + Συνομιλία PDF',
      sub1: {
        desc: 'Η διγλωσσική ανάγνωση σας επιτρέπει να συγκρίνετε το πρωτότυπο κείμενο και τη μετάφραση πλευρά προς πλευρά, βελτιώνοντας την αποτελεσματικότητα της ανάγνωσης.',
        title: 'Διγλώσσα ανάγνωση',
      },
      sub2: {
        desc: 'Η τεχνητή νοημοσύνη αναλύει και συνοψίζει, και μπορεί να απαντήσει στις ερωτήσεις σας με βάση το περιεχόμενο του PDF.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'Μεταφρασμός PDF με ισχύ AI για μεγαλύτερη ακρίβεια και αποτελεσματικότητα.',
        title: 'Ακρίβεια και Εfficience',
      },
      title: 'Μετάφραση PDF',
    },
    aiAssistant: {
      desc: 'Ανατροπή της Μεταφραστικής Εργασίας στον Ιστό σε Μέθοδο Πιο Ευέλικτη και Προσβάσιμη',
      panel1: {
        desc: 'Οι δίγλωσσες μεταφράσεις με διασταύρωση βοηθούν να συγκρίνετε το πρωτότυπο κείμενο με τη μετάφραση, ώστε να κατανοήσετε καλύτερα και να βελτιώσετε την αποτελεσματικότητα της ανάγνωσής σας.',
        title: 'Δίγλωσση Μετάφραση',
      },
      panel2: {
        left: {
          desc: 'Όταν περιηγείστε σε μια ιστοσελίδα, αιχμήστε το ποντίκι πάνω από το περιεχόμενο που θέλετε να μεταφράσετε για να δείτε τη μετάφραση.',
          title: 'Μεταφρασμός Στολής',
        },
        right: {
          desc: 'Κατά την περιήγηση σε μια ιστοσελίδα, επιλέξτε το κείμενο που θέλετε να μεταφραστεί για να δείτε τη μετάφραση.',
          title: 'Μετάφραση Επιλογής Κειμένου',
        },
      },
      panel3: {
        one: {
          desc: 'Μεταφράστε και σύνοψτε ιστοσελίδες και βίντεο περιεχόμενο οποιαδήποτε στιγμή, οπουδήποτε, για μια πιο ομαλή εμπειρία!',
          title: 'Κλικ και Επιλογή',
        },
        three: {
          desc: 'Το μοντέλο μεγάλου языка που οδηγείται από τεχνητή νοημοσύνη διασφαλίζει την ακρίβεια και τη συνέπεια της μετάφρασης για μια βελτιωμένη εμπειρία ανάγνωσης.',
          title: 'Με Στοχοθεσία Τεχνητής Νοημοσύνης',
        },
        two: {
          desc: 'Πλήρης κάλυψη πολλαγών γλωσσών, δίγλωσση ανάγνωση χωρίς φραγμούς, μεταφρασμός με ένα κλικ - εμπειρία την διαφορά!',
          title: 'Πιο Συγκριτικό και Ευκολότερο',
        },
      },
      panel4: {
        tab1: {
          desc: 'Ο εμπειρογνώμονας σας για αποτελεσματικότητα - χρησιμοποιώντας το ChatGPT, ο Noam μεταφράζει και σύνοψιζει περιεχόμενο βίντεο του YouTube για να σας εξοικονομήσει χρόνο!',
          key: 'Βίντεο',
          title: 'Μετάφραση και Σύνοψη Βίντεο',
        },
        tab2: {
          desc: 'Κάντε κλικ για να μεταφράσετε εικόνες κατά την περιήγηση στο διαδίκτυο.',
          key: 'Εικόνα',
          title: 'Μετάφραση Εικόνας',
        },
        tab3: {
          desc: 'Εξάγει αμέσως βασικές πληροφορίες από ιστοσελίδες και παρέχει σύνοψη, βελτιώνοντας την αποτελεσματικότητα της ανάγνωσης σας.',
          key: 'Ιντερνετ',
          title: 'Μετάφραση & Σύνοψη Ιστού',
        },
        tag1: 'Απλό',
        tag2: 'Αποτελεσματικός',
        tag3: 'Εύκολο να κατανοήσεις',
      },
      title: 'βοηθός τεχνητής νοημοσύνης',
    },
    getStart: 'Ξεκινήστε',
    getStartedForFree: 'Ξεκινήστε δωρεάν',
    howItWork: {
      desc: 'Το Noam ενσωματώνει μοντέλα ΤΝ για να προσφέρει στους χρήστες μια έξυπνη εμπειρία για μεταφρασμό και σύνοψη ιστοσελίδων σε διάφορες γλώσσες, μεταφρασμό PDF και εικόνων καθώς και μεταφρασμό και σύνοψη βίντεο',
      title: 'Πώς λειτουργεί',
    },
    lastBlock: { desc: 'Καλύτερη μεταφραστική τεχνολογία AI για μια πιο ομαλή εμπειρία ανάγνωσης' },
    top: {
      desc: 'Το Noam είναι μια δωρεάν επέκταση AI για προγράμματα περιήγησης που βοηθάτε να μεταφράσετε και να συνοψίσετε ιστοσελίδες, βίντεο και περιεχόμενο PDF.\n      Γίνετε μέλος του Noam και βιώστε τη μαγεία!',
      title1: 'Ένα Μαγικό',
      title2: 'Ένα Κλικ',
    },
    userReviews: {
      desc: 'Αξιολογήσεις πέντε αστεριών στο Chrome Web Store',
      title: 'Αξιολογήσεις Χρηστών',
    },
  },
  installTips: {
    btn: 'Δοκιμάστε Τώρα',
    text: 'Εγκαταστήστε το "Noam Browser Plugin" για να ξεκλειδώσετε περισσότερες λειτουργίες! Διασταύρωση αναφορών ιστού,\n    σύνοψη βίντεο ιστού και άλλα πολλά!',
  },
  locale: {
    af: 'Αφρικανσ',
    am: 'Αμαρικά',
    ar: 'Αραβικά',
    as: 'ασαμέζικα',
    auto: 'Αυτόματη ανίχνευση',
    az: 'Αζερμπαϊτζανέζικα',
    ba: 'Μπασκιρ',
    bg: 'Βουλγάρος',
    bn: 'Μπαγκλανέζικα',
    bo: 'Τιβέταιος',
    bs: 'Βοσνιακός',
    ca: 'Καταλανικά',
    cs: 'Τσεχικά',
    cy: 'Ουαλικός',
    da: 'Δανέζικα',
    de: 'Γερμανικά',
    dsb: 'Κάτω Σορβικά',
    dv: 'Ντιβέη',
    el: 'Ελληνικά',
    en: 'Αγγλικά',
    es: 'Ισπανικά',
    et: 'Εსტώνικα',
    eu: 'Βασκός',
    fa: 'Περσικός',
    fi: 'Φινλανδικά',
    fil: 'Φιλιπινέζος',
    fj: 'φίτζιος',
    fr: 'Γαλλικά',
    frCA: 'Γαλλικά (Καναδάς)',
    ga: 'Ιρλανδός',
    gl: 'Γαλιτσιά',
    gom: 'Κονκάνη',
    gu: 'Γκουτζαράτι',
    ha: 'Χάουσα',
    he: 'Εβραϊκή',
    hi: 'Χίντι',
    hr: 'Κροατιανός',
    hsb: 'Ανωτερ Σορβική',
    ht: 'Αϊτιανή Κρεώλη',
    hu: 'Ουγγρικός',
    hy: 'Αρμένιος',
    id: 'Ινδονησιακή',
    ig: 'Ιγκό',
    ikt: 'Ινουιννάκτυν',
    is: 'Ισλανδικά',
    it: 'Ιταλικός',
    iu: 'Ινουκτίτουτ',
    iuLatn: 'Ινουκτιτούτ (Λατινικά)',
    ja: 'Ιαπωνικά',
    ka: 'Γεωργιανός',
    kk: 'Καζαχικός',
    km: 'Κμερικά',
    kmr: 'Κουρδικά (Βόρεια)',
    kn: 'Καννάδα',
    ko: 'Κορεάτης',
    ku: 'Κουρδικά (Κεντρικό)',
    ky: 'Κιργιζικός',
    ln: 'Λιγκαλά',
    lo: 'Λάο',
    lt: 'Λιθουανικά',
    lug: 'Γάντα',
    lv: 'Λατβιανός',
    lzh: 'Κινέζικα (Λογοτεχνικό)',
    mai: 'Μαϊθίλι',
    mg: 'Μαλαγκάζικα',
    mi: 'Μαόρι',
    mk: 'μακεδονικός',
    ml: 'Μαλαγాలம',
    mnCyrl: 'Μογγολικά (Κυριλλική)',
    mnMong: 'Μογγολικά (Παραδοσιακή)',
    mr: 'Μαράθι',
    ms: 'Μαλαιζικά',
    mt: 'Μαλτέζικα',
    mww: 'Hmong Daw',
    my: 'Μιανμάρ (Βερμικά)',
    nb: 'Νορβηγικός',
    ne: 'Νεπάλι',
    nl: 'Ολλανδικά',
    noSearchLang: 'Η γλώσσα δεν υποστηρίζεται',
    nso: 'Σεσόθο Σα Λεμποά',
    nya: 'Νγιάντζα',
    or: 'Οδιά',
    otq: 'Οτόμι του Κουερετάρο',
    pa: 'Πουντζάμπι',
    pl: 'πολωνικά',
    placeholder: 'Αναζήτηση',
    prs: 'Νταρί',
    ps: 'Παστού',
    pt: 'Πορτογαλικά (Βραζιλία)',
    ptPT: 'Πορτογαλικά (Πορτογαλία)',
    ro: 'Ρουμάνικα',
    ru: 'Ρωσική',
    run: 'Ρουντί',
    rw: 'Κινγιαρουάντα',
    sd: 'Σίντι',
    si: 'Σινχαλά',
    sk: 'Σλοβάκικα',
    sl: 'Σλοβενικά',
    sm: 'σαμόανης',
    sn: 'Σόντα',
    so: 'Σομαλίας',
    sq: 'Αλβανικά',
    srCyrl: 'Σερβικά (Κυριλλική)',
    srLatn: 'Σερβικά ( Λατινική )',
    st: 'Σεσόθο',
    sv: 'Σουηδικός',
    sw: 'Σουαχίλι',
    ta: 'Ταμίλ',
    te: 'Τελούγκου',
    th: 'Ταϊλανδέζος',
    ti: 'Τιγκρινγια',
    tk: 'Τουρκμενικός',
    tlhLatn: 'Κλίνγον',
    tlhPiqd: 'Κλίνγον (pIqaD)',
    tn: 'Σετσουάνα',
    to: 'τονγκάνικος',
    tr: 'Τουρκικά',
    tt: 'Τατάρ',
    ty: 'Ταϊτική',
    ug: 'Ουιγούρι',
    uk: 'Ουκρανικός',
    ur: 'Ουρντού',
    uz: 'Ουζμπεκ ( Λατινικά )',
    vi: 'Βιετναμέζικα',
    xh: 'Χόσα',
    yo: 'Γιορούμπα',
    yua: 'Γιουκατέκ Μάγια',
    yue: 'Καntonέζικο (παραδοσιακό)',
    zh: 'Κινέζικα',
    zhHans: 'Κινέζικα Απλοποιημένη',
    zhHant: 'Κινεζικά Παραδοσιακά',
    zu: 'Ζουλού',
  },
  login: {
    and: 'και',
    btn: 'Σύνδεση με το Google',
    btn1: 'Σύνδεση Τώρα',
    desc: 'Συνδεθείτε για να ξεκλειδώσετε περισσότερες εμπειρίες',
    policy: 'Πολιτική Προστασίας Προσωπικών Δεδομένων',
    terms: 'Όροι Χρήσης',
    tips: 'Με την εγγραφή, συμφωνώ με τους',
    title: 'Καλώς ήρθατε στο Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Ακολουθήστε', twitter: 'Twitter' },
    legal: {
      policy: 'Πολιτική Προστασίας Προσωπικών Δεδομένων',
      terms: 'Όροι Χρήσης',
      title: 'Νομικός',
    },
    product: {
      image: 'Μετάφραση Εικόνας',
      pdf: 'Μετάφραση PDF',
      title: 'Προϊόντα',
      video: 'Μετάφραση και Σύνοψη Βίντεο',
      web: 'Μετάφραση & Σύνοψη Ιστού',
    },
    resources: { title: 'Πόροι' },
    tools: { title: 'Εργαλεία', pdf: 'Μετάφραση PDF' },
  },
  pageHeader: {
    contact: 'Επικοινωνία',
    help: 'Βοήθεια',
    logout: 'Αποσύνδεση',
    logoutSucc: 'Αποσυνδέθηκε.',
    pricing: 'Τιμολόγηση',
    settings: 'Ρυθμίσεις',
    signUp: 'Σύνδεση',
  },
  pdf: {
    autoDetect: 'Αυτόματη Αναγνώριση',
    cancelBtn: 'Ακύρωση',
    cancelUpload: 'Ακύρωση',
    chatPdf: {
      summaryError: 'Η σύνοψη απέτυχε, προσπαθήστε ξανά αργότερα',
      chatError: 'Η συνομιλία απέτυχε, προσπαθήστε ξανά αργότερα',
      Search: 'Αναζήτηση',
      cancel: 'Ακύρωση',
      chatTitle: 'Καλώς ήρθατε στο Noam! Εδώ είναι μια περίληψη του PDF σας:',
      clear: 'Καθαρό',
      clearContent:
        'Αυτό θα ξεκινήσει μια νέα συνομιλία. Η τρέχουσα συνομιλία δεν θα αποθηκευτεί. Είστε σίγουροι;',
      clearDialogTitle: 'Παρακαλώ επιβεβαιώστε',
      clearSucc: 'Καθαρισμένο',
      copy: 'Αντιγραφή',
      copySucc: 'Αντιγραφημένο',
      delete: 'Διαγραφή',
      deleteCancel: 'Ακύρωση',
      deleteContent: 'Αυτό το PDF δεν μπορεί να ανακτηθεί μετά την διαγραφή. Είστε σίγουροι;',
      deleteOk: 'Διαγραφή',
      deleteSuccess: 'Διαγράφηκε',
      deleteTitle: 'Επιβεβαίωση Διαγραφής',
      expand: 'Κατάρρευση',
      historyTitle: 'Ιστορία',
      listError:
        'Αποτυχία φόρτωσης της λίστας ανάγνωσης. Παρακαλώ προσπαθήστε αργότερα ή επικοινωνήστε με την υποστήριξη.',
      loading: 'Φορτώνει...',
      noDataDesc: 'Δεν υπάρχει ιστορικό ακόμη.',
      noMore: 'Δεν υπάρχει άλλο περιεχόμενο.',
      placeholder: 'Ζητήστε οτιδήποτε για αυτό το PDF',
      summaryTitle: 'Μπορεί να σας ενδιαφέρουν αυτές οι ερωτήσεις:',
    },
    collectionEmpty: 'Η συλλογή σας είναι άδεια.',
    collectionTab: 'Σημειώσεις',
    dataLoading: 'Φορτώνει...',
    dialogContent: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό;',
    dialogTitle: 'Παρακαλώ επιβεβαιώστε',
    download: {
      both: 'δίγλωσσο',
      btn: 'Αποθήκευση',
      cancel:
        'Το κλείσιμο αυτού του παραθύρου θα ακυρώσει τη λήψη του PDF. Είστε σίγουροι ότι θέλετε να το ακυρώσετε;',
      desc: 'Αποθήκευση στην συσκευή: Κατεβάζει τις μεταφράσεις ως εικόνες. Αποθήκευση & Εκτύπωση: Κατεβάζει τις μεταφράσεις στη πρωτότυπη μορφή, με υποστήριξη αντιγραφής.',
      download: 'Λήψη',
      downloadMsg1: 'Πρόοδος Μετάφρασης PDF:',
      downloadMsg2: 'Αναμενόμενος Χρόνος Υπολειπόμενος:',
      downloadSucc: 'Το PDF είναι έτοιμο! Κάντε κλικ για αποθήκευση.',
      downloadTip: 'Λήψη PDF. Μην κλείσετε αυτό το παράθυρο για να αποφύγετε σφάλματα λήψης.',
      error: 'Αποτυχία αποθήκευσης. Προσπαθήστε να εκτυπώσετε αντί替代.',
      fileName: 'Όνομα Αρχείου:',
      fileType: 'Τύπος αρχείου:',
      loading: 'Αποθήκευση...',
      loading2: 'Φορτώνει...',
      minute: 'Λεπτά...',
      msg1: 'Ορισμένες μεταφράσεις σε αυτό το έγγραφο είναι πιο длинές από το πρωτότυπο κείμενο και μπορεί να επικαλύπτονται στο κατεβασμένο αρχείο. Συνιστούμε να διαβάσετε στην ιστοσελίδα.',
      msg2: 'Η μετάφραση δεν έχει ολοκληρωθεί ακόμη. Παρακαλώ κάντε λήψη αφού ολοκληρωθεί η μετάφραση.',
      msg3: '2. Μερικές μεταφράσεις είναι πολύ μακριές. Διαβάστε στην ιστοσελίδα για να αποφύγετε την επικάλυψη κειμένου.',
      msg4: 'Οι εργασίες μετάφρασης βρίσκονται σε εξέλιξη. Παρακαλώ δοκιμάστε ξανά αφού ολοκληρωθούν.',
      progress:
        'Μεταφράση PDF. Προόδος: {{progress}}, Εκτιμώμενος χρόνος υπολειπόμενος: {{minutes}} λεπτά...',
      save: 'Αποθήκευση στη συσκευή',
      savePrint: 'Αποθήκευση & Εκτύπωση',
      success: 'Ληφθηκε',
      trans: 'Μόνο Μετάφραση',
      transContinue: 'Συνέχισε τη μετάφραση',
    },
    downloadBtn: 'Λήψη',
    dragTipModal: {
      black: 'διάστημα',
      leftKey: 'αριστερό κουμπί',
      ok: 'Κατάλαβα',
      press: 'Πάτησε',
      tips: 'να σύρετε και να δείτε',
    },
    entry: 'PDFs',
    fileErrMsg:
      'Η ανάγνωση του αρχείου απέτυχε. Παρακαλώ προσπαθήστε αργότερα ή επικοινωνήστε με την υποστήριξη.',
    fileMsg: 'Τρέχουσα μέγεθος αρχείου:',
    fileMsg2: 'Παρακαλώ ανεβάστε ένα αρχείο μικρότερο από 300MB.',
    freeBannerBtn: 'Αναβάθμιση',
    freeBannerTips: 'Ο Όριο των Ελεύθερων Μεταφράσεων PDF Έχει Επιτευχθεί',
    guide: {
      placeholder: 'Επικολλήστε τον σύνδεσμο PDF εδώ',
      start: 'Αρχή Μετάφρασης',
      text1: 'Διγλωσσική ανάγνωση',
      text2:
        'Διαβάστε δίγλωσσα για να συγκρίνετε το πρωτότυπο κείμενο και τη μετάφραση πλευρά προς πλευρά, βελτιώνοντας την αποτελεσματικότητά σας.',
      text3: 'Συνομιλία με το PDF σας',
      text4:
        'Ανάλυση και σύνοψη με τη δύναμη της ΤΝ. Αναρωτήστε για το PDF σας και λάβετε άμεσες απαντήσεις.',
      text5: 'Ακριβές & Ειδικότερο',
      text6: 'Μετάφραση PDF με ενίσχυση AI για μεγαλύτερη ακρίβεια και αποτελεσματικότητα.',
      title1: 'Δίγλωσση Μετάφραση',
      title2: 'Συνομιλία με το PDF σας',
      toast: 'Παρακαλώ εισάγετε έναν έγκυρο διαδικτυακό σύνδεσμο PDF που τελειώνει με .pdf',
    },
    hasTransTask: 'Ένα έργο μετάφρασης βρίσκεται σε εξέλιξη. Παρακαλώ περιμένετε.',
    hoverTrans: 'Παράγραφοι Μεταφρασης Με Σύνοψη',
    initial: 'Μεταφράστε το PDF',
    installText: 'Η ολοκληρωμένη λύση για τις καθημερινές μεταφράσεις σας',
    installText2: 'Παρακαλώ εγκαταστήστε起首 την επέκταση',
    installTips:
      'Εγκαταστήστε την επέκταση για ακόμη περισσότερες μεταφράσεις PDF και πιο ομαλές μεταφράσεις ιστοσελίδων:',
    kw: 'κομψό καρφί',
    link: 'σύνδεσμος',
    listError:
      'Απέτυχε το φορτωμένο των PDF. Παρακαλώ δοκιμάστε αργότερα ή επικοινωνήστε με την υποστήριξη.',
    memoTotalCount: 'Σύνολο 1 στοιχείο',
    new: 'νέο αρχείο',
    noId: 'Αναγνωριστικό αρχείου δεν βρέθηκε.',
    notPdf: 'Μόνο αρχεία PDF.',
    okBtn: 'Διαγραφή',
    okBtn2: 'Κατάλαβα',
    original:
      'Είστε μια εξαιρετικά ακριβής και αξιόπιστη τεχνητή νοημοσύνη σχεδιασμένη για να δημιουργεί έξοδο JSON που συμμορφώνεται ακριβώς με ένα καθορισμένο σχήμα JSON.\n\nΠρέπει να ακολουθήσετε αυτούς τους κανόνες:\n1. Παρατηρήστε αυστηρά τη δομή του σχήματος JSON.\n2. Συμπαραστάστε ακριβώς όλα τα είδη δεδομένων, τα απαιτούμενα πεδία και τους περιορισμούς.\n3. ΜΗΝ συμπεριλάβετε κανένα επιπλέον κείμενο, εξήγηση, markdown ή σχόλια.\n4. Εκτυπώστε ΜΟΝΟ το αντικείμενο JSON — χωρίς μπλοκ κώδικα, χωρίς προλόγιο, χωρίς περιτύλιγμα.\n\nΟι πληροφορίες του σχήματος παρέχονται παρακάτω.\n- Όνομα Σχήματος: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Παράλληλος',
    parseErrDialogContent:
      'Ο σύνδεσμος αυτού του PDF δεν μπορεί να μεταφραστεί απευθείας. Παρακαλώ κατεβάστε το PDF και ανεβάστε το για μετάφραση.',
    parseErrTips: 'Αποτυχία ανάλυσης αρχείου',
    parseFileToast:
      'Αποτυχία ανάλυσης αρχείου. Παρακαλώ δοκιμάστε αργότερα ή επικοινωνήστε με την υποστήριξη.',
    pdfLoading: 'Ανάλυση...',
    searchPlaceholder: 'Αναζήτηση',
    selectTrans: 'Επιλέξτε Κείμενο για Μετάφραση',
    shareBtn: 'Κοινοποίηση',
    shareBtnText1: 'Δημιουργία Σύνδεσμου Κοινή χρήσης',
    shareBtnText2: 'Ενημέρωση Κοινόχρηστου Περιεχομένου',
    shareModal: {
      cancel: 'Ακύρωση',
      copy: 'Αντιγραφή',
      copySucc: 'Σύνδεσμος Αντιγράφηκε',
      custom: 'Προσαρμογή:',
      errMsg:
        'Το επιλεγμένο περιεχόμενο δεν έχει μεταφραστεί πλήρως ακόμα. Παρακαλώ μεταφράστε το πριν το διαμοιραστείτε.',
      gen: 'Κοινοποίηση',
      modify: 'Επεξεργασία',
      notSupport: 'Η γλώσσα αυτή δεν υποστηρίζεται προς το παρόν.',
      page: 'Σελίδες',
      pageNuErr: 'Παρακαλώ εισάγετε έναν έγκυρο αριθμό σελίδας.',
      range: 'Εμβέλεια:',
      remain: 'λειπόμενο',
      remain1: 'Συνολικός εκτιμώμενος χρόνος:',
      search: 'Αναζήτηση',
      settings: 'Ρυθμίσεις Κοινή χρήσης:',
      shareSetting: 'Ρυθμίσεις Κοινή Χρήσης',
      shareText: 'Κοινοποίηση',
      shareTips: 'Κοινοποιήστε τον μεταφρασμένο σύνδεσμο PDF με τους φίλους σας:',
      sourceLang: 'Από:',
      target: 'Προς:',
      text1: 'Ρυθμίσεις Κοινή Χρήσης',
      text2: 'Δημιουργία Συνδέσμου Κοινή χρήσης',
      totalPage: 'Συνολικά 1 σελίδα',
      trans: 'Μεταφράζω',
      translateTips:
        'Συμβουλή: Εάν η μετάφραση διαρκεί πολύ, μπορείτε να κλείσετε αυτό το παράθυρο και να το μοιραστείτε αργότερα.',
      translating: 'Μεταφράση PDF...',
      update: 'Ενημέρωση Σύνδεσμου Κοινή χρήσης',
    },
    shareMsg1: 'Δημιουργήθηκε σύνδεσμος κοινής χρήσης.',
    shareMsg2: 'Το κοινό περιεχόμενο ενημερώθηκε.',
    shareMsg3:
      'Αποτυχία δημιουργίας συνδέσμου κοινής χρήσης. Προσπαθήστε αργότερα ξανά ή επικοινωνήστε με την υποστήριξη.',
    shareMsg4:
      'Απέτυχε η ενημέρωση του κοινόχρηστου περιεχομένου. Προσπαθήστε ξανά αργότερα ή επικοινωνήστε με την υποστήριξη.',
    shareTips: 'Η μετάφραση του PDF σας είναι έτοιμη! Μοιραστείτε την με τους φίλους σας.',
    start: 'Ξεκινήστε την δωρεάν δοκιμή σας',
    thumbnail: 'Πίνακας Περιεχομένων',
    toast1: 'Φόρτωση PDF. Παρακαλώ δοκιμάστε αργότερα ξανά.',
    toast2: 'Η περιεχόμενη του PDF επεξεργάζεται. Η διάλογος δεν υποστηρίζεται αυτήν τη στιγμή.',
    toast3: 'Λήψη αρχείου. Παρακαλώ δοκιμάστε ξανά αφού ολοκληρωθεί η λήψη.',
    toolbar: { Adjust: 'Καθορίζω', autoFit: 'Αυτόματη Προσαρμογή' },
    trans: 'Μετάφραση',
    transSucc: 'Η μετάφραση ήταν επιτυχής!',
    unLoginToast: 'Παρακαλώ συνδεθείτε για να χρησιμοποιήσετε αυτήν την λειτουργία.',
    uploadBtn: 'Ανέβασμα',
    uploadErr:
      'Η μεταφόρτωση του αρχείου απέτυχε. Παρακαλώ δοκιμάστε αργότερα ή επικοινωνήστε με την υποστήριξη.',
    uploadErrSignUrl:
      'Απέτυχε η λήψη URL μεταφόρτωσης. Παρακαλώ δοκιμάστε αργότερα ή επικοινωνήστε με την υποστήριξη.',
    uploadMsg1: 'Σύρετε και αφήστε το αρχείο σας εδώ.',
    uploadMsg2: 'Υποστηριζόμενοι Τύποι Αρχείων: PDF  |  Μέγιστο Μέγεθος Αρχείου: 300MB',
    uploadMsg3: 'Κάντε κλικ για να επιλέξετε ή σύρετε και αφήστε τα αρχεία εδώ.',
    uploading: 'Ανέβασμα',
    uploadingMsg: 'Μεταφόρτωση. Παρακαλώ περιμένετε.',
    uploadingMsg1: 'Το αρχείο μεταφορτώνεται. Παρακαλώ προσπαθήστε αργότερα ξανά.',
    uploadingMsg2: 'Ένα αρχείο μετατρέπεται αυτήν τη στιγμή. Προσπαθήστε ξανά αργότερα.',
    uploadingMsg3:
      'Το αίτημα για την πρόοδο μετατροπής απέτυχε. Παρακαλώ δοκιμάστε ξανά αργότερα ή επικοινωνήστε με την υποστήριξη.',
    uploadingMsg4:
      'Ο Noam δεν μπορεί να αποκτήσει πρόσβαση στα τοπικά αρχεία. Παρακαλώ ανεβάστε χειροκίνητα ένα PDF για μετάφραση.',
    uploadingMsg5:
      'Αποτυχία ανάκτησης URL αρχείου. Παρακαλώ δοκιμάστε ξανά αργότερα ή επικοινωνήστε με την υποστήριξη.',
    video: 'βίντεο',
    vipBannerBtn: 'Αναβάθμιση',
    vipBannerTips: 'Έχετε φτάσει το όριο μετάφρασης PDF για αυτόν τον μήνα.',
    webTrans: 'Πλήρης Αναφορά Σταυρού',
  },
  pricing: {
    FAQ: 'Συχνές Ερωτήσεις',
    FQAObj: {
      a1: 'Ναι, ο Noam προσφέρει ένα δωρεάν πρόγραμμα που μπορείτε να χρησιμοποιήσετε αμέσως.',
      a2: 'Προσφέρουμε τρία σχέδια μέλους: Pro, Pro+ και Enterprise. Μπορείτε να επιλέξετε να πληρώνετε μηνιαία ή ετήσια. Η ετήσια τιμολόγηση προσφέρει σημαντικά εξοικονόμηματα.',
      a3: 'Όλες οι λειτουργίες είναι διαθέσιμες και στα δύο σχέδια. Η κύρια διαφορά είναι το κόστος: τα ετήσια συνδρομή έχουν συνολικά χαμηλότερο κόστος. Οι μηνιαίες συνδρομές χρεώνται κάθε μήνα, ενώ τα ετήσια σχέδια χρεώνται μία φορά τον χρόνο.',
      a4: 'Μπορείτε να ακυρώσετε τη συνδρομή σας ανά πάσα στιγμή στις Ρυθμίσεις Λογαριασμού σας.',
      q1: 'Υπάρχει κάποιο δωρεάν πρόγραμμα;',
      q2: 'Ποι Plans τιμολόγησης και επιλογές πληρωμής είναι διαθέσιμες;',
      q3: 'Ποια είναι η διαφορά μεταξύ της μηνιαίας και της ετήσιας συνδρομής;',
      q4: 'Πώς ακυρώνω την συνδρομή μου;',
    },
    around: 'Γύρω',
    billedMonthly: 'Χρέωση μηνιαία',
    billedYearly: 'Χρέωση ετήσια',
    day: 'μέρα',
    desc: 'Συγκρίνετε τα Σχέδια & Επιλέξτε το Καλύτερο',
    detailedCompare: 'Σύγκριση Προγραμμάτων',
    discount: '20% Έκπτωση',
    enterprise: {
      benefit1: 'Προτεραιτική Υποστήριξη Πελατών',
      benefit2: 'Πολλοί Χρήστες',
      benefit3: 'Επιτομημένες Λύσεις',
      benefit5: 'Εξειδικευμένος Διαχειριστής Λογαριασμών',
      btn: 'Επικοινωνήστε Μαζί Μας',
      recommendText: 'Προσαρμοσμένες Σχέσεις (≥3 άτομα)',
      talkToUs: 'Επικοινωνήστε μαζί μας',
    },
    free: {
      benefit1: 'Αυτόματη μετάφραση 100 φορές/ημέρα',
      benefit2: 'Μετάφραση Ιστοσελίδας & Σύνοψη',
      benefit3: '30 Μεταφράσεις Εικόνων',
      benefit4: 'Μετάφραση και Σύνοψη Βίντεο',
      benefit5: '10 Μεταφράσεις PDF',
      benefit6: '5.000 tokens',
      btn: 'Δοκιμάστε το δωρεάν',
      recommendText: 'Δωρεάν δοκιμή',
    },
    imageTranslation: 'Μετάφραση Εικόνας',
    month: 'μήνας',
    monthly: 'Μηνιαία',
    pageTitle: 'Τιμολόγηση',
    pdf: {
      chat: 'Ερωτήματα Τόκινων PDF',
      maxPage: 'Μέγιστο αριθμός σελίδων ανά PDF',
      translation: 'Μετάφραση PDF',
    },
    preMonth: 'Π्रतি μήνα',
    pro: {
      benefit1: 'Προτεραιτική Υποστήριξη Πελατών',
      benefit2: '1.000.000 tokens/μήνα',
      benefit3: 'Μετάφραση και Σύνοψη Ιστοσελίδας',
      benefit4: '200 Μεταφράσεις Εικόνων',
      benefit5: 'Μετάφραση και Σύνοψη Βίντεο',
      benefit6: '200 Μεταφράσεις PDF',
      btn: 'Ξεκινήστε',
      recommendText: 'Πιο Πρόσφατο',
    },
    proPlus: {
      benefit1: 'Προτεραιτική Υποστήριξη Πελατών',
      benefit2: '3.000.000 tokens/μήνα',
      benefit3: 'Μετάφραση και Σύνοψη Ιστοσελίδας',
      benefit4: '500 Μεταφράσεις Εικόνων',
      benefit5: 'Μετάφραση και Σύνοψη Βίντεο',
      benefit6: '500 Μεταφράσεις PDF',
      recommendText: 'Καλύτερη Τιμή',
    },
    video: { summary: 'Σύνοψη βίντεο', translation: 'Μετάφραση βίντεο' },
    web: {
      contrastiveTranslation: 'Δίγλωσση Μετάφραση',
      dictionaryTranslation: 'Επιλογή Μετάφρασης',
      hoverTranslation: 'Μεταφρασμός Επιπλέον',
      instantTranslation: 'Αυτόματη Μετάφραση',
      summary: 'Σύνοψη Ιστοσελίδας',
    },
    yearly: 'Ετήσιο',
  },
  privacy: {
    block1:
      'Η Noam («Noam», «εμείς», «μας» ή «εμάς») σεβέται την ιδιωτικότητά σας και δεσμεύεται να προστατεύσει οποιαδήποτε πληροφορία που αποκτούμε από εσάς ή σχετικά με εσάς. Αυτή η Πολιτική Προστασίας Προσωπικών Δεδομένων περιγράφει τις πρακτικές μας σχετικά με τη συλλογή ή τη χρήση προσωπικών δεδομένων από τη χρήση του ιστότοπού μας, των εφαρμογών και των υπηρεσιών μας (συναθροιστικά οι «Υπηρεσίες»). Αυτή η Πολιτική Προστασίας Προσωπικών Δεδομένων δεν ισχύει για το περιεχόμενο που διαχειριζόμαστε για λογαριασμό των πελατών των επιχειρηματικών προϊόντων μας, όπως το API μας. Η χρήση αυτών των δεδομένων υπόκειται στην συμφωνία πελάτη μας, η οποία καλύπτει την πρόσβαση και τη χρήση αυτών των προϊόντων.',
    block10:
      'Υλοποιούμε εμπορικά εύλογα τεχνικά, διοικητικά και οργανωτικά μέτρα για την προστασία των çevрозων και εκτός σύνδεσης προσωπικών δεδομένων από απώλεια, λανθασμένη χρήση, μη εξουσιοδοτημένη πρόσβαση, αποκάλυψη, τροποποίηση ή εχθρικές ενέργειες. Ωστόσο, καμία μετάδοση μέσω Διαδικτύου ή email δεν μπορεί να εγγυηθεί πλήρη ασφάλεια ή ακρίβεια. Ειδικότερα, τα emails που στέλνονται σε εμάς ή από εμάς ενδέχεται να μην είναι ασφαλή. Επομένως, θα πρέπει να είστε ιδιαίτερα προσεκτικοί όταν αποφασίζετε τι πληροφορίες να στείλετε σε εμάς μέσω της υπηρεσίας ή email. Επιπλέον, δεν είμαστε υπεύθυνοι για οποιαδήποτε παρεμπόδιση των ρυθμίσεων προστασίας προσωπικών δεδομένων ή των μέτρων ασφαλείας στην υπηρεσία ή στις ρυθμίσεις προστασίας προσωπικών δεδομένων ή μέτρα ασφαλείας των Ιστότοπων Τρίτων Κυβερνητών. Θα διατηρήσουμε τα προσωπικά σας δεδομένα για όσο χρειαστεί για να σας παρέχουμε υπηρεσίες ή για άλλους νόμιμους επιχειρηματικούς σκοπούς, όπως η επίλυση διαφωνιών, αιτίες ασφαλείας και υγείας ή η συμμόρφωση με τις νομικές μας υποχρεώσεις. Η διάρκεια διατήρησης των προσωπικών δεδομένων θα εξαρτηθεί από πολλούς παράγοντες, όπως το ποσό, η φύση, η ευαισθησία των πληροφοριών, οι πιθανοί κίνδυνοι μη εξουσιοδοτημένης χρήσης ή αποκάλυψης, οι σκοποί για τους οποίους επεξεργαζόμαστε τις πληροφορίες και άλλες νομικά δεσμευτικές σκέψεις.',
    block11:
      'Ενδέχεται να ενημερώνουμε αυτήν την Πολιτική Προστασίας Προσωπικών Δεδομένων κατά καιρούς. Όταν το κάνουμε αυτό, θα δημοσιεύσουμε μια ενημερωμένη έκδοση σε αυτήν τη σελίδα, εκτός εάν άλλες διατάξεις απαιτούνται από το ισχύον δίκαιο.',
    block12:
      'Εάν έχετε οποιεσδήποτε απαντήσεις ερωτήσεις ή ανησυχίες σχετικά με αυτήν την Πολιτική Προστασίας Προσωπικών Δεδομένων, παρακαλώ επικοινωνήστε με την υπηρεσία πελατών μας. Email:',
    block2:
      'Συλλέγουμε τις ακόλουθες προσωπικές πληροφορίες («Προσωπικές Πληροφορίες») που σχετίζονται με εσάς:',
    block3:
      'Πληροφορίες που παρέχετε εσείς: Όταν δημιουργείτε έναν λογαριασμό για να χρησιμοποιήσετε τις υπηρεσίες μας ή για να επικοινωνήσετε μαζί μας, συλλέγουμε προσωπικές πληροφορίες ως εξής:',
    block4:
      'Προσωπικά δεδομένα που λαμβάνονται αυτόματα από τη χρήση των υπηρεσιών σας: Όταν αποκτάτε πρόσβαση, χρησιμοποιείτε ή αλληλεπιδράτε με τις υπηρεσίες, λαμβάνουμε τα ακόλουθα δεδομένα σχετικά με την πρόσβασή σας, τη χρήση σας ή την αλληλεπίδρασή σας («Τεχνικά Δεδομένα»):',
    block5: 'Μπορούμε να χρησιμοποιήσουμε προσωπικές πληροφορίες για τους ακόλουθους σκοπούς:',
    block6:
      'Σύνοψη ή απροσδιόριστη πληροφορία: Μπορούμε να συγκεντρώνουμε ή να απροσδιόρισουμε προσωπικές πληροφορίες για να αποτρέψουμε την επαναχρησιμοποίησή τους για λόγους ταυτοποίησης και να χρησιμοποιήσουμε τέτοιες πληροφορίες για να αναλύσουμε την αποτελεσματικότητα των υπηρεσιών μας, να βελτιώσουμε και να προσθέσουμε χαρακτηριστικά στις υπηρεσίες μας, να διεξαγάγουμε έρευνα και για παρόμοιους σκοπούς. Επιπλέον, μπορούμε να αναλύσουμε τη γενική συμπεριφορά και τα χαρακτηριστικά των χρηστών των υπηρεσιών μας και να μοιραστούμε συγκεντρωμένη πληροφορία με τρίτους, να δημοσιεύσουμε τέτοιου είδους συγκεντρωμένη πληροφορία ή να την καταστήσουμε γενικά διαθέσιμη. Μπορούμε να συλλέξουμε συγκεντρωμένη πληροφορία μέσω των υπηρεσιών, μέσω cookies και μέσω άλλων μέσων που περιγράφονται στην παρούσα Πολιτική Προστασίας Προσωπικών Δεδομένων. Θα διατηρούμε και χρησιμοποιούμε απροσδιόριστη πληροφορία σε ανώνυμη ή απροσδιόριστη μορφή και δεν θα επιχειρήσουμε να αναγνωρίσουμε ξανά τέτοιες πληροφορίες εκτός εάν απαιτείται από το νόμο.',
    block7:
      'Σε ορισμένες περιπτώσεις, ενδέχεται να παρέχουμε τα προσωπικά σας δεδομένα σε τρίτους χωρίς περαιτέρω ειδοποίηση για εσάς, εκτός εάν ο νόμος το απαιτεί:',
    block8:
      'Σε εξάρτηση από τη γεωγραφική σας θέση, τα άτομα στην Ευρωπαϊκή Οικονομική Περιοχή, το Ηνωμένο Βασίλειο και παγκοσμίως μπορεί να έχουν ορισμένα νομικά δικαιώματα σχετικά με τα προσωπικά τους δεδομένα. Για παράδειγμα, μπορείτε να έχετε το δικαίωμα να:',
    block9:
      'Η υπηρεσία μπορεί να περιέχει συνδέσμους προς άλλες ιστοσελίδες που δεν λειτουργούνται ή ελέγχονται από την Noam, συμπεριλαμβανομένων υπηρεσιών κοινωνικής δικτύωσης («Ιστοσελίδες Τρίτων Φορέων»). Οι πληροφορίες που μοιράζεστε με τις Ιστοσελίδες Τρίτων Φορέων θα διέπονται από τις συγκεκριμένες πολιτικές προστασίας προσωπικών δεδομένων και τους όρους χρήσης των Ιστοσελίδων Τρίτων Φορέων, όχι από την παρούσα Πολιτική Προστασίας Προσωπικών Δεδομένων. Προσφέρουμε αυτούς τους συνδέσμους για λόγους διευκόλυνσης και δεν συνεπάγεται ενδοσίωσή μας ή αξιολόγηση αυτών των ιστοσελίδων. Παρακαλούμε επικοινωνήστε απευθείας με τις Ιστοσελίδες Τρίτων Φορέων για πληροφορίες σχετικά με τις πολιτικές προστασίας προσωπικών δεδομένων και τους όρους τους.',
    subBlock1:
      'Πληροφορίες Λογαριασμού: Όταν δημιουργείτε έναν λογαριασμό στην πλατφόρμα μας, συλλέγουμε πληροφορίες σχετικές με τον λογαριασμό σας, συμπεριλαμβανομένου του ονόματος σας, των στοιχείων επικοινωνίας, των διαπιστευτηρίων λογαριασμού, των πληροφοριών της κάρτας πληρωμής και του ιστορικού συναλλαγών («Πληροφορίες Λογαριασμού»).',
    subBlock10: 'Παροχή, διαχείριση, συντήρηση και/ή ανάλυση υπηρεσιών·',
    subBlock11: 'Επικοινωνία μαζί σου',
    subBlock12: 'Ανάπτυξη νέων προϊόντων και υπηρεσιών·',
    subBlock13:
      'Πρόληψη απάτης, ποινικής δραστηριότητας ή ακατάλληλης χρήσης των υπηρεσιών μας, καθώς και προστασία της ασφάλειας των συστημάτων πληροφορικής, της αρχιτεκτονικής και των δικτύων μας·',
    subBlock14: 'Πραγματοποίηση μεταφορών επιχειρήσεων·',
    subBlock15:
      'Υπακοή στις νομικές υποχρεώσεις και τις νομικές διαδικασίες, προστασία των δικαιωμάτων μας, της ιδιωτικότητας, της ασφάλειας ή της ιδιοκτησίας, καθώς και αυτών των συστατικών εταιρειών μας, σας ή άλλων τρίτων μερών.',
    subBlock16:
      'Προμηθευτές και Προμηθευτές Υπηρεσιών: Για να μας βοηθήσουν να καλύψουμε τις επιχειρηματικές λειτουργικές ανάγκες και να εκτελέσουμε ορισμένες υπηρεσίες και λειτουργίες, ενδέχεται να παρέχουμε προσωπικές πληροφορίες σε προμηθευτές και προμηθευτές υπηρεσιών, συμπεριλαμβανομένων προμηθευτών υπηρεσιών φιλοξενίας, προμηθευτών υπηρεσιών σύννεφου, άλλων προμηθευτών υπηρεσιών πληροφορικής, λογισμικού επικοινωνίας μέσω email και προμηθευτών υπηρεσιών ανάλυσης ιστοσελίδων κ.λπ. Αυτοί οι συνεργάτες θα έχουν πρόσβαση, επεξεργαστούν ή θα αποθηκεύσουν προσωπικές πληροφορίες μόνο κατόπιν οδηγιών μας κατά την εκτέλεση των καθηκόντων τους προς εμάς.',
    subBlock17:
      'Μεταφορές Επιχειρήσεων: Εάν εμπλακούμε σε στρατηγικές συναλλαγές, αναδιοργανώσεις,宣告破產, ανάληψεις宣告破產 ή μεταβίβαση υπηρεσιών σε άλλον πάροχο (συναθροιστικά, «Συναλλαγές»), οι προσωπικές σας πληροφορίες και άλλες πληροφορίες ενδέχεται να διαμοιραστούν με τα αντίπαλα συγγενεύματα συναλλαγών και άλλους φορείς που βοηθούν στις συναλλαγές κατά τη διάρκεια της εξέτασης και να μεταβιβαστούν ως μέρος των συναλλαγών μαζί με άλλα περιουσιακά στοιχεία σε μια διαδοχή ή συγγενική εταιρεία.',
    subBlock18:
      'Νομικές απαιτήσεις: Μπορούμε να μοιραστούμε τις προσωπικές σας πληροφορίες με κρατικούς φορείς, ομοτίμους στον κλάδο ή άλλους τρίτους, συμπεριλαμβανομένων των πληροφοριών σχετικά με την αλληλεπίδρασή σας με τις υπηρεσίες μας, (1) εάν απαιτείται από το νόμο ή εάν πιστεύουμε ότι μια τέτοια ενέργεια είναι απαραίτητη για τη συμμόρφωση με νομικές υποχρεώσεις· (2) για την προστασία και την υπεράσπιση των δικαιωμάτων ή περιουσιακών στοιχείων μας· (3) εάν καθοριστούμε μονομερώς ότι υπάρχει παραβίαση των όρων, πολιτικών ή νόμων μας· (4) για την ανίχνευση ή την πρόληψη απάτης ή άλλων παράνομων δραστηριοτήτων· (5) για την προστασία των προϊόντων, εργαζομένων ή χρηστών μας ή της δημόσιας ασφάλειας, ασφαλείας, ακεραιότητας· ή (6) για την υπεράσπιση έναντι νομικής ευθύνης.',
    subBlock19:
      'Πρόσβαση στις προσωπικές σας πληροφορίες και πληροφορίες σχετικά με τον τρόπο επεξεργασίας τους.',
    subBlock2:
      'Όταν χρησιμοποιείτε τις υπηρεσίες μας, συλλέγουμε προσωπικές πληροφορίες από τις εισαγωγές σας, τα ανεβασμένα αρχεία ή τις σχολιασμούς που μας παρέχετε («Περιεχόμενο»).',
    subBlock20: 'Αιτήστε την διαγραφή των προσωπικών σας πληροφοριών από τα αρχεία μας.',
    subBlock21: 'Επιβεβαιώστε ή ενημερώστε τα προσωπικά σας στοιχεία.',
    subBlock22:
      'Μεταφορά των προσωπικών σας πληροφοριών σε τρίτο μέρος (μεταφορική δυνατότητα δεδομένων).',
    subBlock23: 'Περιορίστε τον τρόπο επεξεργασίας των προσωπικών σας δεδομένων.',
    subBlock24:
      'Ανακαλέστε τη συγκατάθεσή σας—όταν βασιζόμαστε στη συγκατάθεση ως τη νομική βάση για την επεξεργασία, μπορείτε να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή.',
    subBlock25: 'Αντιτεθείτε στον τρόπο επεξεργασίας των προσωπικών σας δεδομένων.',
    subBlock26: 'Βελτιωώντας τις υπηρεσίες μας και διεξάγοντας έρευνα·',
    subBlock3:
      'Πληροφορίες Επικοινωνίας: Εάν μας στείλετε μηνύματα, θα συλλέξουμε το όνομά σας, τις επικοινωνιακές σας πληροφορίες και το περιεχόμενο των μηνυμάτων σας («Πληροφορίες Επικοινωνίας»).',
    subBlock4:
      'Πληροφορίες Κοινωνικών Μέσων: Διαθέτουμε σελίδες σε ιστοσελίδες κοινωνικών μέσων όπως το Instagram, Facebook, Medium, Twitter, YouTube και LinkedIn. Όταν αλληλεπιδράτε με τις σελίδες μας στα κοινωνικά μέσα, συλλέγουμε τις προσωπικές πληροφορίες που επιλέγετε να μας παρέχετε, όπως τα στοιχεία επικοινωνίας σας («Πληροφορίες Κοινωνικών Μέσων»). Επιπλέον, οι εταιρείες που φιλοξενούν τις σελίδες μας στα κοινωνικά μέσα μπορεί να μας παρέχουν συγκεντρωμένες πληροφορίες και ανάλυση σχετικά με τις δραστηριότητες μας στα κοινωνικά μέσα.',
    subBlock5:
      'Δεδομένα Καταγραφής (Log Data): Πληροφορίες που αποστέλλονται αυτόματα από τον περιηγητή σας κατά τη χρήση των υπηρεσιών μας. Τα δεδομένα καταγραφής περιλαμβάνουν τη διεύθυνση πρωτοκόλλου Διαδικτύου (IP) σας, τον τύπο και τις ρυθμίσεις του περιηγητή σας, την ημερομηνία και την ώρα των αιτημάτων σας καθώς και τον τρόπο με τον οποίο αλληλεπιδράτε με τον ιστότοπό μας.',
    subBlock6:
      'Δεδομένα Χρήσης: Μπορούμε να συλλέγουμε αυτόματα πληροφορίες σχετικά με τη χρήση σας της υπηρεσίας, όπως οι τύποι περιεχομένου που προβάλλετε ή με τα οποία αλληλεπιδράτε, τα χαρακτηριστικά που χρησιμοποιείτε, οι ενέργειες που λαμβάνετε, καθώς και ο אזור χρόνου σας, η χώρα, η ημερομηνία και η ώρα πρόσβασης, ο πράκτορας χρήστη και η έκδοση του, ο τύπος υπολογιστή ή κινητού συσκευής, καθώς και η σύνδεση του υπολογιστή σας.',
    subBlock7:
      'Πληροφορίες Συσκευής: Αυτές περιλαμβάνουν το όνομα της συσκευής, το λειτουργικό σύστημα, τον αναγνωριστικό συσκευής και το πρόγραμμα περιήγησης που χρησιμοποιείτε. Οι πληροφορίες που συλλέγονται μπορεί να εξαρτώνται από τον τύπο της συσκευής που χρησιμοποιείτε και τις ρυθμίσεις της.',
    subBlock8:
      'Κουκίες: Χρησιμοποιούμε κουκίες για την λειτουργία και διαχείριση των υπηρεσιών μας καθώς και για τη βελτίωση της εμπειρίας σας. Μια «κουκιά» είναι πληροφορία που στέλνει ένας ιστότοπος που επισκέπτεστε στον φυλλομετρητή σας. Μπορείτε να ρυθμίσετε τον φυλλομετρητή σας για να αποδέχεται όλες τις κουκίες, να απορρίπτει όλες τις κουκίες ή να σας ειδοποιεί όταν παρέχεται μια κουκιά, ώστε να μπορέσετε να αποφασίσετε κάθε φορά αν θα την αποδεχτείτε. Ωστόσο, η απόρριψη των κουκιών μπορεί να σας εμποδίσει να χρησιμοποιήσετε ορισμένα μέρη ή χαρακτηριστικά του ιστότοπου ή να επηρεάσει αρνητικά την εμφάνιση ή τη λειτουργία τους. Για περισσότερες πληροφορίες σχετικά με τις κουκίες, επισκεφτείτε το All About Cookies.',
    subBlock9:
      'Αναλυτικά Δεδομένα: Μπορεί να χρησιμοποιούμε διάφορα διαδικτυακά προϊόντα αναλυτικών δεδομένων που χρησιμοποιούν cookies για να μας βοηθήσουν να αναλύσουμε πώς οι χρήστες χρησιμοποιούν τις υπηρεσίες μας και να βελτιώσουμε την εμπειρία σας κατά τη χρήση των υπηρεσιών.',
    subTitle1: 'Προσωπικά δεδομένα που συλλέγουμε',
    subTitle2: 'Πώς Χρησιμοποιούμε Προσωπικές Πληροφορίες',
    subTitle3: 'Αποκάλυψη Προσωπικών Δεδομένων',
    subTitle4: 'Τα Δικαιώματα σας',
    subTitle5: 'Σύνδεσμοι προς Άλλους Ιστότοπους',
    subTitle6: 'Ασφάλεια και Διατήρηση Πληροφοριών',
    subTitle7: 'Τροποποίηση Πολιτικής Προστασίας Προσωπικών Δεδομένων',
    subTitle8: 'Πώς να επικοινωνήσετε μαζί μας',
    title: 'Πολιτική Προστασίας Προσωπικών Δεδομένων',
    updateTime: 'Ενημερώθηκε: 15 Μαρτίου 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Αποδοχή όλων',
    text: 'Για να βελτιώσουμε την εμπειρία σας, χρησιμοποιούμε cookies για την προσαρμογή περιεχομένου και υπηρεσιών.',
    title: 'Ο ιστότοπος αυτός χρησιμοποιεί cookies',
  },
  slogen: 'Ο πιο εύκολος βοηθός τεχνητής νοημοσύνης',
  stripe: {
    contact: 'Επικοινωνήστε μαζί μας στο contact@noam.tools για οποιαδήποτε ερώτηση!',
    fail: {
      btn: 'Επαναπροσπάθεια',
      text1: 'Δεν μπορέσαμε να επεξεργαστούμε την πληρωμή σας.',
      text2: 'Ελέγξτε τη σύνδεσή σας και προσπαθήστε ξανά.',
      title: 'Η πληρωμή απέτυχε',
    },
    succ: {
      btn: 'Ας πάμε',
      text1: 'Καλώς ήρθατε στο Noam',
      text2: 'ας ξεκινήσουμε!',
      title: 'Συγχαρητήρια',
    },
  },
  terms: {
    block1: 'Ευχαριστούμε για τη χρήση του Noam!',
    block10:
      '(α) Τέλη και Χρέωση. Θα πληρώσετε όλα τα τέλη («Τέλη») σύμφωνα με τις τιμές και τους όρους στη σχετική σελίδα τιμών ή όπως συμφωνηθεί γραπτώς μεταξύ μας. Διατηρούμε το δικαίωμα να διορθώσουμε σφάλματα τιμών ή λάθη ακόμη και εάν έχουμε εκδώσει τιμολόγια ή λάβει πληρωμή. Θα παρέχετε πλήρη και ακριβή πληροφορίες χρέωσης, συμπεριλαμβανομένης μιας έγκυρης και εξουσιοδοτημένης μεθόδου πληρωμής. Θα χρεώσουμε τη μέθοδο πληρωμής σας περιοδικά όπως συμφωνηθεί, αλλά ενδέχεται να αλλάξουμε τον προγραμματισμένο χρόνο χρέωσης με λογικό τρόπο. Εξουσιοδοτείτε την Noam, τις θυγατρικές της εταιρείες και τους τρίτους επεξεργαστές πληρωμών να χρεώσουν τη μέθοδο πληρωμής σας. Εάν η πληρωμή σας αποτύχει, θα σας στείλουμε γραπτή ειδοποίηση και ενδέχεται να αναστείλουμε την πρόσβαση στην Υπηρεσία έως ότου λάβουμε την πληρωμή. Εκτός εάν另行 καθοριστεί στην παρούσα συμφωνία, οι πληρωμές δεν επιστρέφονται.',
    block11:
      '(b) Φόροι. Εκτός αν另有规定, οι Τέλη δεν περιλαμβάνουν κανέναν ομοσπονδιακό, κρατικό, τοπικό ή ξένο φόρο, δασμό ή παρόμοια χρέωση («Φόροι»). Είστε υπεύθυνοι για όλους τους Φόρους που σχετίζονται με τις αγορές σας, εξαιρουμένων των Φόρων που βασίζονται στο καθαρό εισόδημά μας, για τους οποίους θα σας εκπονήσουμε τιμολόγιο. Συμφωνείτε να πληρώσετε άμεσα αυτούς τους Φόρους και να μας παρασχετέτε νομικά έγκυρες δηλώσεις απορρήτου, καθώς και να αποκτήσετε τις απαραίτητες συγκαταθέσεις για τον χειρισμό τέτοιων δεδομένων, και εγγυάστε μας ότι χειρίζεστε τα δεδομένα αυτά σύμφωνα με το ισχύον δίκαιο.',
    block12:
      '(γ) Αλλαγές Τιμών. Μπορούμε να αλλάξουμε τις τιμές μας κοινοποιώντας σας μέσω του λογαριασμού σας και/ή του ιστότοπού μας. Οι αυξήσεις τιμών θα вступουν σε ισχύ αμέσως μετά την ανάρτηση. Οποιεσδήποτε αλλαγές τιμών θα ισχύουν για τα Χρεώματα του λογαριασμού σας μετά την ημερομηνία έναρξης ισχύος της αλλαγής.',
    block13:
      '(δ) Διαφορές και Καθυστερημένες Πληρωμές. Εάν επιθυμείτε να διαφωνήσετε για οποιοδήποτε Χρέος ή Φόρο, επικοινωνήστε με το contact@noam.tools εντός τριάντα (30) ημερών από την ημερομηνία του τιμολογίου.',
    block14:
      '(ε) Ελεύθερη Χρήση. Δεν επιτρέπεται η δημιουργία πολλαπλών λογαριασμών για την αποκτήση δωρεάν πιστώσεων. Εάν διαπιστώσουμε ότι δεν χρησιμοποιείτε τις δωρεάν πιστώσεις με καλή πίστη, ενδέχεται να σας χρεώσουμε με τυπικές τέλη ή να σταματήσουμε την παροχή πρόσβασης στην Υπηρεσία.',
    block15:
      '(α) Απόρρητο. Μπορείτε να αποκτήσετε πρόσβαση σε εμπιστευτικές πληροφορίες της Noam. Μπορείτε να χρησιμοποιείτε εμπιστευτικές πληροφορίες μόνο όπως επιτρέπεται σύμφωνα με αυτές τις προδιαγραφές για σκοπούς χρήσης της Υπηρεσίας. Δεν μπορείτε να αποκαλύψετε εμπιστευτικές πληροφορίες σε οποιοδήποτε τρίτο μέρος και θα προστατεύετε τις εμπιστευτικές πληροφορίες με τρόπο όχι λιγότερο προστατευτικό από αυτόν με τον οποίο προστατεύετε τις δικές σας παρόμοιες εμπιστευτικές πληροφορίες, τουλάχιστον με εύλογη προσοχή. Οι εμπιστευτικές πληροφορίες είναι μη δημόσιες πληροφορίες που ορίζονται ως εμπιστευτικές από την Noam ή που θα πρέπει εύλογα να αντιμετωπιστούν ως εμπιστευτικές υπό τις περιστάσεις, συμπεριλαμβανομένου του λογισμικού, των προδιαγραφών και άλλων μη δημοσίων επιχειρηματικών πληροφοριών. Οι εμπιστευτικές πληροφορίες δεν περιλαμβάνουν πληροφορίες που: (1) καθίστανται γενικά διαθέσιμες στο κοινό χωρίς καμία δική σας αδυναμία; (2) είχατε στην κατοχή σας χωρίς καμία υποχρέωση εμπιστευτικότητας πριν την λάβετε σύμφωνα με αυτές τις προδιαγραφές; (3) σας αποκαλύπτεται νόμιμα από τρίτο μέρος χωρίς καμία υποχρέωση εμπιστευτικότητας· ή (4) αναπτύσσονται ανεξάρτητα από εσάς χωρίς τη χρήση των εμπιστευτικών πληροφοριών. Μπορείτε να αποκαλύψετε εμπιστευτικές πληροφορίες εάν απαιτηθεί από το νόμο, το δικαστήριο ή άλλη κυβερνητική εντολή, αλλά πρέπει να poskytτήσετε προηγούμενη γραπτή ειδοποίηση στην Noam με εύλογο τρόπο και, κατά το δυνατόν, να καταβάλετε εύλογες προσπάθειες για περιορισμό του εύρους της αποκάλυψης, συμπεριλαμβανομένης της βοήθειάς μας στην αντίθεση σε αιτήματα αποκάλυψης.',
    block16:
      '(β) Ασφάλεια. Πρέπει να εφαρμόσετε λογικές και κατάλληλες μέθοδοι για την προστασία της πρόσβασης σας και της χρήσης της Υπηρεσίας. Εάν ανακαλύψετε τυχόν ευπάθειες ή παραβιάσεις που σχετίζονται με τη χρήση σας της Υπηρεσίας, πρέπει να επικοινωνήσετε άμεσα με τον Noam και να παρέχετε λεπτομέρειες για την ευπάθεια ή την παραβίαση.',
    block17:
      '((c) Επεξεργασία Προσωπικών Δεδομένων. Εάν χρησιμοποιείτε την Υπηρεσία για την επεξεργασία προσωπικών δεδομένων, πρέπει να παρέχετε νομικά επαρκή δηλώσεις προστασίας προσωπικών δεδομένων και να αποκτήσετε τις απαραίτητες συγκαταθέσεις για την επεξεργασία τέτοιων δεδομένων, και σας εγγυάστε προς εμάς ότι διαχειρίζεστε τα εν λόγω δεδομένα σύμφωνα με το ισχύον δίκαιο.',
    block18:
      'Κατάργηση; Αναστολή. Οι παρόντες όροι θα вступουν σε ισχύ από την πρώτη σας χρήση της Υπηρεσίας και θα παραμείνουν σε ισχύ έως την κατάργηση τους. Μπορείτε να καταργήσετε τους παρόντες όρους ανά πάσα στιγμή για οποιοδήποτε λόγο διακόπτοντας τη χρήση της Υπηρεσίας και του Περιεχομένου. Μπορούμε να καταργήσουμε τους παρόντες όρους με προηγούμενη ειδοποίηση για οποιοδήποτε λόγο. Μπορούμε να καταργήσουμε αμέσως τους παρόντες όρους ειδοποιώντας σας εάν παραβιάσετε ουσιαστικά την Ενότητα 2 (Απαιτήσεις Χρήσης), την Ενότητα 5 (Confidentiality, Security, and Data Protection), την Ενότητα 8 (Διαπίστευση Επίλυσης Διαφορών) ή την Ενότητα 9 (Γενικοί Όροι), ή εάν η σχέση μας με οποιοδήποτε τρίτο πάροχο τεχνολογίας πέραν нашего ελέγχου αλλάξει, ή για συμμόρφωση με το νόμο ή αιτήματα των αρχών. Μπορούμε να αναστείλουμε την πρόσβασή σας στην Υπηρεσία εάν δεν συμμορφώστε με τους παρόντες όρους, ή εάν η χρήση σας θέτει κίνδυνο ασφαλείας για εμάς ή οποιοδήποτε τρίτο μέρος, ή εάν υποψιάζομαι ότι η χρήση σας είναι απάτη ή μπορεί να εκθέσει εμάς ή οποιοδήποτε τρίτο μέρος σε ευθύνη.',
    block19:
      '(b) Επίδραση της Ολοκλήρωσης. Με την ολοκλήρωση, θα πρέπει να σταματήσετε να χρησιμοποιείτε την Υπηρεσία και να επιστρέψετε άμεσα ή να καταστρέψετε οποιαδήποτε εμπιστευτική πληροφορία όπως μας ορίζουμε. Οι διατάξεις αυτών των όρων που κατά τη φύση τους πρέπει να επιβιώσουν μετά την ολοκλήρωση ή την λήξη, συμπεριλαμβανομένων αλλά όχι περιορισμένων στις Ενότητες 3 και 5-9, θα επιβιώσουν.',
    block2:
      'Οι παρόντες Όροι Χρήσης ισχύουν για τη χρήση των υπηρεσιών του Noam, συμπεριλαμβανομένων των διεπαφών προγραμματισμού εφαρμογών, του λογισμικού, των εργαλείων, των υπηρεσιών προγραμματιστών, των δεδομένων, της τεκμηρίωσης και της ιστοσελίδας μας (συναθροιστικά αναφερόμενα ως «Υπηρεσίες»). Με τη χρήση των Υπηρεσιών μας, συμφωνείτε να τηρείτε αυτούς τους όρους. Η Πολιτική Προστασίας Προσωπικών Δεδομένων μας εξηγεί πώς συλλέγουμε και χρησιμοποιούμε προσωπικά δεδομένα.',
    block20:
      'Εγγύηση αποζημίωσης. Θα υπερασπιστείτε, θα αποζημιώσετε και θα διατηρήσετε ασφαλή εμάς, τις θυγατρικές μας εταιρείες και το προσωπικό μας έναντι οποιωνδήποτε απαιτήσεων, απωλειών και εξόδων (συμπεριλαμβανομένων των δικηγορικών αμοιβών) που προκύπτουν από ή σχετίζονται με τη χρήση σας της Υπηρεσίας, συμπεριλαμβανομένου του Περιεχομένου σας, της χρήσης προϊόντων ή υπηρεσιών που σχετίζονται με την Υπηρεσία και της παραβίασης των παρόντων όρων ή ισχύοντος δικαίου.',
    block21:
      '(b) Απόρρητοι περιορισμοί. Η Υπηρεσία παρέχεται «ως έχει». Στο βαθμό που επιτρέπεται από το νόμο, εμείς και οι θυγατρικές εταιρείες μας καθώς και οι δικαιούχοι πνευματικών δικαιωμάτων δεν κάνουμε žádες δηλώσεις ή εγγυήσεις οποιουδήποτε είδους σχετικά με την Υπηρεσία και δεν παρέχουμε εγγυήσεις, συμπεριλαμβανομένων αλλά όχι περιορισμένων στις εγγυήσεις εμπορευσιμότητας, καταλληλότητας για συγκεκριμένο σκοπό, ικανοποιητικής ποιότητας, μη παραβίασης πνευματικών δικαιωμάτων και ήσυχης χρήσης, καθώς και οποιεσδήποτε εγγυήσεις που προκύπτουν από τη διεργασία συναλλαγών ή τη χρήση συναλλαγών. Δεν εγγυόμαστε ότι η Υπηρεσία θα είναι χωρίς διακοπή, ακριβής ή χωρίς λάθη, ή ότι οποιοδήποτε Περιεχόμενο θα είναι ασφαλές, δεν θα χαθεί ή δεν θα τροποποιηθεί.',
    block22:
      '(c) Περιορισμός Ευθύνης. Ούτε εμείς, ούτε οι συστατικές μας εταιρείες, ούτε οι δικαιούχοι άδειας δεν θα είναι υπεύθυνοι για οποιαδήποτε έμμεση, τυχόν, ειδική, επακόλουθη ή τιμωρητική ζημία, συμπεριλαμβανομένης της απώλειας κερδών, της απώλειας φήμης, της απώλειας χρήσης, της απώλειας δεδομένων ή άλλων απωλειών άυλων στοιχείων, ακόμη και εάν λάβαμε προειδοποίηση για την πιθανότητα τέτοιων ζημιών. Σύμφωνα με αυτές τις προϋποθέσεις, η συνολική μας ευθύνη δεν θα υπερβαίνει τα τέλη που πληρώσατε για την Υπηρεσία κατά τους δώδεκα (12) μήνες πριν από την πρόταση αξιώματος ή εκατό ΗΠΑ δολάρια ($100), όποιο είναι μεγαλύτερο. Οι περιορισμοί σε αυτήν την ενότητα ισχύουν στο μέγιστο βαθμό που επιτρέπεται από το ισχύον δίκαιο.',
    block23:
      'Οι Όροι και η χρήση των Υπηρεσιών υπόκεινται στους νόμους των Ηνωμένων Πολιτειών, εξαιρουμένων των κανόνων περί σύγκρουσης νόμων των ΗΠΑ. Η χρήση της Εφαρμογής μπορεί επίσης να υπόκειται σε άλλους τοπικούς, κρατικούς, εθνικούς ή διεθνείς νόμους. Οποιαδήποτε νομική δράση ή διαδικασία σχετική με αυτούς τους Όρους θα εισαχθεί αποκλειστικά στις δικαστικές αρχές των Ηνωμένων Πολιτειών, και συμφωνείτε να υποβάλετε στην προσωπική δικαιοδοσία αυτών των δικαστηρίων.',
    block24:
      'Σχέση των Συμπαραστάσεων. Ο Νοάμ και εσείς είστε ανεξάρτητοι εργαζόμενοι, και κανένα μέρος δεν έχει τη δυνατότητα να αντιπροσωπεύσει ή να δεσμεύσει το άλλο μέρος ή να αναλάβει υποχρεώσεις για το άλλο μέρος χωρίς την προηγούμενη γραπτή συγκατάθεση του άλλου μέρους.',
    block25:
      '(β) Χρήση Μάρκετ. Δεν μπορείτε να χρησιμοποιήσετε το όνομα, τα λογότυπα ή τα εμπορικά σήματα της Noam ή οποιασδήποτε από τις θυγατρικές της εταιρείες χωρίς την προηγούμενη γραπτή συγκατάθεση μας.',
    block26:
      'Εάν οποιοδήποτε άρθρο αυτών των όρων διαπιστωθεί ότι είναι άκυρο, παράνομο ή άκυρο για την εκτέλεση, τα υπόλοιπα άρθρα θα παραμείνουν σε πλήρη ισχύ και εφαρμογή.',
    block3:
      'Εάν είστε κάτω των 18 ετών, πρέπει να λάβετε την άδεια των γονέων σας ή των νομίμων κηδεμόνων για να χρησιμοποιήσετε την Υπηρεσία. Εάν χρησιμοποιείτε την Υπηρεσία εκ μέρους άλλου ατόμου ή οντότητας, πρέπει να είστε εξουσιοδοτημένος να αποδεχτείτε αυτούς τους όρους εκ μέρους τους. Πρέπει να παρέχετε ακριβείς και πλήρεις πληροφορίες για να εγγραφείτε για έναν λογαριασμό. Δεν επιτρέπεται να παρέχετε τα διαπιστευτήρια πρόσβασης ή τον λογαριασμό σας σε οποιονδήποτε εκτός της Оргάνωσης σας, και είστε υπεύθυνος για όλες τις δραστηριότητες που διεξάγονται χρησιμοποιώντας τα διαπιστευτήριά σας.',
    block4:
      '(α) Χρήση της Υπηρεσίας. Μπορείτε να αποκτήσετε πρόσβαση στην Υπηρεσία υπό αυτές τις προϋποθέσεις και σας παρέχουμε ένα μη αποκλειστικό δικαίωμα χρήσης της Υπηρεσίας. Κατά τη χρήση της Υπηρεσίας, θα συμμορφώνεστε με αυτές τις προϋποθέσεις και جميع τις ισχύουσες νομοθεσίες. Εμείς και οι συσταθείσες μας κατέχουμε όλα τα δικαιώματα, τον τίτλο και τα συμφέροντα στην Υπηρεσία.',
    block5:
      '(β) Σχόλια. Καλούμε τα σχόλια, τα σχολιασμούς, τις ιδέες, τις προτάσεις και τις βελτιώσεις. Εάν παράσχετε οποιοδήποτε τέτοιο περιεχόμενο, μπορούμε να το χρησιμοποιήσουμε χωρίς κανένα περιορισμό και χωρίς αποζημίωση προς εσάς.',
    block6:
      '(γ) Περιορισμοί. Δεν επιτρέπεται: (1) η χρήση της Υπηρεσίας με τρόπο πουละβιάζει, αφαιρεί ή παραβιάζει οποιεσδήποτε δικαιώματα τρίτων; (2) ο αντίστροφος μηχανισμός, η αποσυμπίεση, η αποσυναρμολόγηση, η μετάφραση ή οποιαδήποτε άλλη προσπάθεια ανακάλυψης του κώδικα προέλευσης ή των υποκείμενων συστατικών των μοντέλων, των αλγορίθμων και των συστημάτων της Υπηρεσίας (εκτός εάν οι εν λόγω περιορισμοί απαγορεύονται από το ισχύον δίκαιο); (3) η χρήση του αποτελέσματος της Υπηρεσίας για την ανάπτυξη μοντέλων που ανταγωνίζονται το Noam; (4) η εξαγωγή δεδομένων ή αποτελεσμάτων από την Υπηρεσία με χρήση οποιωνδήποτε αυτοματοποιημένων ή προγραμματιστικών μεθόδων, εκτός εάν επιτραπεί μέσω του API, συμπεριλαμβανομένης της συλλογής δεδομένων (scraping), της συλλογής πληροφοριών από ιστοσελίδες (web harvesting) ή της εξαγωγής δεδομένων από το διαδίκτυο; (5) η αναπαράσταση του αποτελέσματος της Υπηρεσίας ως τεχνητά δημιουργημένο όταν δεν είναι так, ή οποιαδήποτε άλλη παραβίαση των πολιτικών χρήσης μας; (6) η αγορά, η πώληση ή η μεταφορά κλειδιών API χωρίς την προηγούμενη συγκατάθεσή μας; ή (7) η παροχή σε εμάς οποιασδήποτε προσωπικής πληροφορίας παιδιών κάτω των 13 ετών ή της ισχύουσας ηλικίας ψηφιακής συγκατάθεσης. Θα συμμορφώνεστε με τυχόν όρια ρυθμού και άλλες απαιτήσεις στην τεκμηρίωσή μας.',
    block7:
      '(δ) Υπηρεσίες Τρίτων. Οποιοδήποτε λογισμικό, υπηρεσίες ή άλλα προϊόντα τρίτων μελών που σχετίζονται με την Υπηρεσία διέπονται από τους δικούς τους όρους, και δεν είμαστε υπεύθυνοι για προϊόντα τρίτων μελών.',
    block8:
      'Το περιεχόμενό σας. Μπορείτε να παρέχετε εισόδους («Εισόδοι») στην Υπηρεσία και να λάβετε εξόδους («Εξόδους») που δημιουργούνται και επιστρέφονται на βάση των Εισόδων (συλλογικά αναφερόμενα ως «Περιεχόμενο»). Μεταξύ των μερών, και τόσο όσο επιτρέπεται από το ισχύον δίκαιο, κατεχέτε όλα τα Εισόδα. Η Noam μπορεί να χρησιμοποιήσει το Περιεχόμενο για την παροχή και συντήρηση της Υπηρεσίας, τη συμμόρφωση με τα ισχύοντα νόμους και την επιβολή των πολιτικών μας. Είστε υπεύθυνοι για το Περιεχόμενο, συμπεριλαμβανομένης της διασφάλισης ότι δεν παραβιάζει κανέναν ισχύον νόμο ή τους παρόντες όρους.',
    block9:
      '(β) Ακρίβεια. Η τεχνητή νοημοσύνη και το μηχανικό μάθηση είναι ταχεία αναπτυσσόμενοι τομείς έρευνας. Προσπαθούμε συνεχώς να βελτιώσουμε την υπηρεσία μας για να την καθιστούμε πιο ακριβή, αξιόπιστη, ασφαλή και ωφέλιμη. Λαμβάνοντας υπόψη τη πιθανολογική φύση του μηχανικού μάθησης, η χρήση της υπηρεσίας μας μπορεί να οδηγήσει σε λανθασμένες εξόδους σε ορισμένες περιπτώσεις, οι οποίες ενδέχεται να μην αντανακλούν με ακρίβεια πραγματικά άτομα, места ή γεγονότα. Θα πρέπει να αξιολογήσετε κατάλληλα την ακρίβεια οποιασδήποτε εξόδου με βάση την περίπτωση χρήσης σας, συμπεριλαμβανομένης της χειροκίνητης ανασκόπησης των εξόδων.',
    subTitle1: 'Εγγραφή και Πρόσβαση',
    subTitle10: 'Διαχωρισιμότητα',
    subTitle2: 'Απαιτήσεις Χρήσης',
    subTitle3: 'Περιεχόμενο',
    subTitle4: 'Τέλη και Πληρωμή',
    subTitle5: 'Εμπιστευτικότητα, Ασφάλεια και Προστασία Δεδομένων',
    subTitle6: 'Όρος και Παράλειψη',
    subTitle7: 'Εγγύηση αποζημιώσεων; Αποποίηση ευθύνης; Περιορισμός ευθύνης',
    subTitle8: 'Νόμος διεύθυνσης και δικαιοδοσία',
    subTitle9: 'Γενικοί Όροι',
    title: 'Όροι Χρήσης',
    updateTime: 'Ενημερώθηκε: 15 Μαρτίου 2024',
  },
  trialModal: {
    btn: 'Ξεκινήστε Τώρα (Μόνο $0,99)',
    chat: 'ChatPDF',
    desc1: 'Μετά την δοκιμαστική περίοδο, θα χρεωθείτε με ετήσιο τέλος των 180 δολαρίων ΗΠΑ',
    desc2: 'Ακύρωση ανά πάσα στιγμή',
    focus: 'Εστίαση',
    hover: 'Μεταφρασμός αιωρούμενου κέρματος',
    image: 'Μετάφραση εικόνας',
    installBtn: 'Εγκαταστήστε τώρα για να λάβετε το δώρο σας',
    memo: 'Διαχείριση αγαπημένων',
    pdf: 'Παράλληλη μετάφραση PDF',
    realtime: 'Αυτόματο μεταφραστικό',
    select: 'Μετάφραση επιλογής λέξεων',
    title: 'Δώρο καλωσορίσματος',
    trialText: 'Δοκιμαστική Προσφορά 7 Ημερών',
    video: 'Μετάφραση βίντεο',
    videoSummary: 'Σύνοψη βίντεο',
    web: 'Παράλληλη Μετάφραση',
    webSummary: 'Σύνοψη ιστοσελίδας',
  },
  upgradeModal: {
    btn: 'Αναβάθμιση Τώρα',
    chat: {
      free: 'Έχετε досягσει το όριο του ChatPDF',
      pro: 'Έχετε досягσει το όριο ChatPDF για αυτόν τον μήνα',
    },
    contactStr:
      'Παρακαλώ περιμένετε για την επόμενη επαναφορά ή επικοινωνήστε μαζί μας στο contact@noam.tools.',
    limitAlertStr: 'Έχετε φτάσει το όριο του δωρεάν плάνου σας. Αναβαθμίστε για να συνεχίσετε.',
    more: 'Εμφάνιση Προγραμμάτων',
    pageLimit: { free: 'Έχετε φτάσει το όριο σελίδων του PDF' },
    title: 'Υπόδειξη',
    upgradeAlertStr: 'Έχετε φτάσει το όριο του δωρεάν плάνου σας. Αναβαθμίστε για να συνεχίσετε.',
    upload: {
      free: 'Έχετε φτάσει το όριο μεταφράσεων PDF',
      pro: 'Έχετε φτάσει το όριο μεταφράσεων PDF για αυτόν τον μήνα',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Εγγραφείτε Τώρα',
      label: 'Οφέλη Νέου Χρήστη:',
      remain: 'Μόνο 30 απομένουν',
      text: 'Μόνο 100 θέσεις διαθέσιμες! Παραλάβετε τη δική σας τώρα!',
    },
  },
  aiPdfTranslator: {
    title: 'Ελεύθερος AI Μεταφραστής PDF: Μεταφράστε PDF με Σύγκριση σε οποιαδήποτε Γλώσσα',
    desc: 'Μεταφράστε εύκολα αρχεία PDF σε οποιαδήποτε γλώσσα με τεχνητή νοημοσύνη. Συγκρίνετε το πρωτότυπο και το μεταφρασμένο κείμενο δίπλα-δίπλα, γρήγορα και δωρεάν.',
    keywords: 'GPT-4、Βοηθός ΤΝΕ、Μετάφραση、Σύνοψη、Εστίαση、ChatPDF、Μνήμη、πολυτέλεια',
    sourceToTarget: {
      title: 'Ελεύθερο Εργαλείο Μετάφρασης PDF: μεταφράστε το {{source}} στο {{target}} δωρεάν',
      desc: 'Μεταφράστε τα αρχεία PDF σας από οποιαδήποτε γλώσσα προέλευσης στη προτιμώμενη σας γλώσσα δωρεάν. Γρήγορη, ακριβής και ασφαλής μετάφραση PDF με την υποστήριξη προηγμένης τεχνολογίας AI.',
    },
    headerIntroduce: {
      title: 'Noam: Που Θαπερνάει Από Μια Απλή Μεταφραστική Υπηρεσία Στο Διαδίκτυο',
      introduce1: {
        title: 'Noam · Αναγνώστης PDF',
        desc: '✨Μεταφρασμός δίπλα-δίπλα + AI Q&A. Μεταφράστε γρήγορα και ακριβώς PDF σε τη γλώσσα στόχο σας. Αναρωτήστε ελεύθερα για το περιεχόμενο για να αποκτήσετε μια βαθύτερη κατανόηση των αρχείων PDF σας.',
      },
      introduce2: {
        title: 'Noam · Επεκτάσεις Παράλληλης Μετάφρασης',
        desc: '👏Λύστε όλες τις ανάγκες μεταφρασης ιστοσελίδων σας:',
        detail1: { title: 'Μετάφραση Ιστοσελίδας:', desc: 'Παράλληλη δίγλωσση προβολή' },
        detail2: { title: 'Μετάφραση Λέξης:', desc: 'Γρήγορη μετάφραση με ένα κλικ' },
        detail3: { title: 'Αυτόματο Μετάφραση:', desc: 'Μεταφράστε λέξεις ή προτάσεις αμέσως.' },
        detail4: {
          title: 'Μετάφραση Εικόνας:',
          desc: 'Αντικαταστήστε τις εικόνες με μεταφρασμένες.',
        },
        detail5: {
          title: 'Μετάφραση βίντεο:',
          desc: 'Δίγλωσσους υποτίτλους για καλύτερη προβολή.',
        },
        footer:
          'Εμπειρία περισσότερων δυνατοτήτων ανάγνωσης με ενίσχυση τεχνητής νοημοσύνης για πιο έξυπνη μετάφραση!',
      },
    },
    subtitle: 'Μετάφραση PDF στο Διαδίκτυο Δωρεάν',
    introduce: {
      module1: {
        detail1: {
          title: 'Εικονική Παράλληλη Μετάφραση PDF σε Πραγματικό Χρόνο',
          desc1:
            'Εμφάνιση αμέσως πρωτογενών και μεταφρασμένων περιεχομένων σε μια συγχρονισμένη, δίπλα-δίπλα διάταξη',
          desc2: 'Συγκρίνετε εύκολα και τα δύο εκδόματα με συγχρονισμένη κύλιση',
          desc3: ' Διατηρήστε την ίδια μορφοποίηση για μια συνεπή εμπειρία ανάγνωσης',
        },
        detail2: {
          title: 'Ακριβής Προσανατολισμός και Επιβεβαίωση Περιεχομένου',
          desc1:
            'Εξαιρετική ευθυγράμμιση μεταξύ πρωτογενκού και μεταφρασμένου κειμένου για εύκολη επαλήθευση',
          desc2: 'Κάθε τμήμα περιεχομένου συμφωνεί ακριβώς μεταξύ των δύο εκδόσεων',
          desc3:
            'Εντοπίστε και επιλύστε γρήγορα τις ανωμαλίες μεταφράσεων για αξιόπιστα αποτελέσματα',
        },
      },
      module2: {
        detail1: {
          title: 'Πολλαπλά Προηγμένα Μοντέλα ΤΝΝ για Ακριβή Μετάφραση',
          desc1:
            'Επιλέξτε από πρωτοποριακά μοντέλα ΤΝ για να συμφωνήσουν με τις απαιτήσεις μεταφράσεως σας',
          desc2:
            'Βεβαιωθείτε για βέλτιστα αποτελέσματα για διάφορους τύπους εγγράφων και βιομηχανίες',
          desc3: 'Οι ευέλικτες επιλογές μοντέλων προσφέρουν προσαρμοσμένες λύσεις για κάθε σενάριο',
        },
        detail2: {
          title: 'Προηγμένη Μετάφραση ΤΝΕ για Οποιοδήποτε Τύπο Περιεχομένου',
          desc1: 'Το ισχυρό μοντέλο AI μας εξασφαλίζει υψηλή ακρίβεια και φυσική κατανόηση γλώσσας',
          desc2: 'Διαχειρίζεται τεχνικά, ακαδημαϊκά και δημιουργικά έγγραφα με ευκολία',
          desc3: 'Παρέχει αξιόπιστα αποτελέσματα για όλες τις ανάγκες μεταφράσεώς σας',
          desc4: 'Εξυπνη προσαρμογή σε διαφορετικούς τύπους περιεχομένου για βέλτιστη απόδοση',
        },
      },
      module3: {
        detail1: {
          title: 'Εξυπνη Ανταλλαγή Εγγράφων',
          desc1:
            'Συμπαραστάστε εύκολα με τα αρχεία PDF και παρουσιάσεων σας χρησιμοποιώντας προηγμένη τεχνολογία τεχνητής νοημοσύνης',
          desc2:
            'Ζητήστε άμεσα ερωτήσεις σχετικά με το περιεχόμενο των εγγράφων και λάβετε ακριβείς απαντήσεις',
          desc3: 'Γρήγορα δημιουργήστε συνοπτικά περίληψη για μακρά έγγραφα',
        },
        detail2: {
          title: 'Εξορυξη αναλυσης περιεχομενου και Α无缝 ενσωματωση',
          desc1:
            'Εξάγετε βασικές πληροφορίες και αναλύστε σύνθετα δεδομένα με τη δύναμη της τεχνητής νοημοσύνης για κατανόηση',
          desc2: 'Αποκτήστε πληροφορίες για τεχνικά, ακαδημαϊκά ή δημιουργικά υλικά',
          desc3:
            'Ενσωματώνεται ομαλά με το μεταφραστή PDF μας για μια ολοκληρωμένη λύση διαχείρισης εγγράφων',
        },
      },
      module4: {
        detail1: {
          title: 'Πέρα από τη Μετάφραση PDF: Ενιαία Λύση Μετάφρασης Ιστοσελίδων',
          desc: 'Ανακαλύψτε την ισχυρή επέκταση δίπλα-δίπλα μετάφρασης μας, σχεδιασμένη για κάθε σενάριο διαδικτυακής ανάγνωσης.',
          desc1:
            'Μετάφραση ιστοσελίδας: Απολαύστε διγλωσσικό περιεχόμενο με συγχρονισμένη προβολή πλευρά προς πλευρά',
          desc2: 'Μετάφραση Λέξεων: Μεταφράστε αμέσως τις επισημασμένες λέξεις με μια μόνο κλικ',
          desc3:
            'Αυτόματο Μετάφραση: Μεταφράστε οποιοδήποτε κείμενο ή πρόταση azonίως για γρήγορη κατανόηση',
          desc4:
            'Μετάφραση Εικόνων: Αντικατάσταση αυτόματη των πρωτογενών εικόνων με μεταφρασμένες εκδόσεις',
          desc5:
            'Μετάφραση βίντεο: Προβλέπετε βίντεο με διγλωσσικούς υπότιτλους για μια βελτιωμένη εμπειρία',
        },
      },
    },
    question: {
      title: 'Συχνές Ερωτήσεις',
      answer1: {
        title: 'Είναι δωρεάν η χρήση του Noam PDF Translator για τη μετάφραση PDF;',
        content:
          'Ναι, μπορείτε να μεταφράσετε PDF δωρεάν με το Sider PDF Translator! Προσφέρουμε μια δωρεάν квота των 5.000 tokens, η οποία είναι επαρκής για τη μετάφραση των περισσότερων PDF εγγράφων που συναντώνται συνήθως στην αγορά. Εάν χρειαστεί να μεταφράσετε μεγαλύτερα αρχεία ή να χρησιμοποιήσετε προηγμένες λειτουργίες, μπορείτε να επιλέξετε να αναβαθμίσετε στα προμετωπίδια μας σχέδια για ακόμη περισσότερες δυνατότητες.',
      },
      answer2: {
        title: 'Πόσο ακριβής είναι ο μεταφραστής PDF Noam;',
        content:
          'Ο μεταφραστής PDF Noam παρέχει εξαιρετικά ακριβείς μεταφράσεις αξιοποιώντας προηγμένη τεχνολογία τεχνητής νοημοσύνης και κατανοώντας βαθιά το πλαίσιο των εγγράφων σας. Αν και καμία αυτοματοποιημένη μεταφραση δεν είναι άψογη, η οθόνη δίπλα-δίπλα μας σας επιτρέπει να αναθεωρήσετε και να τροποποιήσετε εύκολα κάθε μεταφραση, διασφαλίζοντας ότι το τελικό αποτέλεσμα ανταποκρίνεται στις προσδοκίες ποιότητας σας. Ζήστε μια αξιόπιστη και ακριβή μεταφραση PDF με το Noam.',
      },
      answer3: {
        title: 'Μπορώ να μεταφράσω σκανάρισμενα PDF;',
        content:
          'Ναι, μπορείτε να μεταφράσετε σκανάρισμενα PDF με την ενσωματωμένη τεχνολογία OCR (αναγνώριση οπτικών χαρακτήρων) μας. Το σύστημα μας εξάγει αυτόματα το κείμενο από σκανάρισμενα έγγραφα και PDF με βάση εικόνες, στη συνέχεια μεταφράζει το περιεχόμενο για εσάς. Αυτό εξασφαλίζει ότι ακόμη και μη επεξεργάσιμα ή μόνο εικονικά PDF μπορούν να μεταφραστούν με ακρίβεια.',
      },
      answer4: {
        title: 'Πόσο χρόνο διαρκεί η μετάφραση;',
        content:
          'Η μετάφραση είναι γρήγορη και αποτελεσματική—τα περισσότερα έγγραφα επεξεργάζονται σε διάστημα από δευτερόλεπτα έως μερικά λεπτά, ανάλογα με το μήκος και τη πολυπλοκότητα τους. Για παράδειγμα, ένα τυπικό PDF με 10 σελίδες συνήθως διαρκεί λιγότερο από 2 λεπτά για μετάφραση. Απολαύστε γρήγορες χρόνους ολοκλήρωσης για όλες τις ανάγκες μεταφρασης των εγγράφων σας!',
      },
      answer5: {
        title: 'Μπορώ να κρατήσω την παράλληλη προβολή για ανάγνωση;',
        content:
          'Ναι, μπορείτε πάντα να διαβάσετε τα έγγραφά σας παράλληλα. Αυτή η διάταξη σας επιτρέπει να συγκρίνετε εύκολα το πρωτότυπο και το μεταφρασμένο περιεχόμενο, διασφαλίζοντας μια ομαλή και αποτελεσματική εμπειρία ανάγνωσης.',
      },
    },
    freeTrial: 'Δωρεάν δοκιμή',
    toLanguage: { title: 'Ζεύγη Μεταφράσεων PDF AI', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'Χαρακτηριστικά',
      blog: 'Βλογ',
      faq: 'Συχνές Ερωτήσεις',
      pricing: 'Τιμολόγηση',
      button: 'Μεταφράστε Τώρα',
    },
    hero: {
      upload: {
        title: 'Ανέβαστε το PDF σας',
        highlight: 'Κάντε κλικ για περιήγηση',
        desc: 'ή σύρετε και αφήστε',
        max: 'Μαξ',
      },
      to: 'σε',
      title: 'Ελεύθερος Μεταφραστής PDF',
      pill: 'Μεταφραστής PDF Με Τεχνολογία ΤΝ',
      model: 'GPT-4 & Claude',
      desc: 'Ακαριαίες, ακριβείς μεταφράσεις που διατηρούν τη πρωτότυπη διάταξη. Το Noam AI υποστηρίζει OCR και παράλληλες προβολές.',
      support: 'Υποστήριξη OCR',
      free: 'Δωρεάν δοκιμή',
      translated: 'Μεταφράστηκε από τον Noam',
      complete: 'Μετάφραση Ολοκληρωμένη',
    },
    ticker: {
      pdf: 'Μετάφραση PDF',
      ocr: 'Τεχνολογία OCR',
      format: ' Διατήρηση Μορφής',
      multi: 'Πολυγλωσσικό',
      side: 'Πλευρά-προς-Πλευρά',
      chat: 'Συνομιλία με PDF',
      web: 'Μετάφραση Ιστού',
      secure: 'Ασφαλές & Ιδιωτικό',
    },
    comparison: {
      bad: {
        title: 'Πρότυπη Μετάφραση',
        head: 'Αποκλεισμός Μορφοποίησης & Σύνθεσης',
        text1: 'Σφάλμα: Σխληρμένη διάταξη. Οι εικόνες έχουν τοποθετηθεί λάθος.',
        text2:
          'Το κείμενο επικαλύπτεται και οι γραμματοσειρές δεν είναι συνεπείς. Δύσκολο στην ανάγνωση και απροфессиональικό...',
      },
      dump: { title: 'Εκχώρηση Κειμένου Χωρίς Μορφοποίηση' },
      good: {
        title: 'Μετάφραση Noam AI',
        tag: 'Τέλεια Απόδοση',
        sub: 'Ιδανική Μορφοποίηση, Εξαισθητοποιημένη στο Συμπερίφρασμα',
      },
      title: 'Γιατί να επιλέξετε το Noam AI;',
      desc: 'Σταματήστε να αγωνίζεστε με μεταφράσεις αντιγραφής-επικόλλησης. Εμπειρέψτε τη διαφορά μεταξύ των τυπικών εργαλείων και της μεταφράσεως μας βασισμένης σε AI με ενίσχυση ngữ cảnhού.',
    },
    showcase: {
      kicker: 'ΥΠΟΒΟΛΗ ΜΕΛΕΤΩΝ',
      title2: 'Οποιαδήποτε Γλώσσα',
      title1: 'Οποιοδήποτε Έγγραφο',
      carousel1: 'Τέχνη',
      carousel2: 'Αρχιτεκτονική',
      note: 'Διαχειριστείτε τεχνικά, ακαδημαϊκά και δημιουργικά έγγραφα με ευκολία.',
      carousel4: 'Ιατρική',
      carousel3: 'Ακαδημαικό περιοδικό',
      carousel5: 'Οικονομικά',
      carousel8: 'Πολιτική',
      carousel6: 'Νόμος',
      carousel7: 'Σύμβολο',
    },
    features: {
      big: {
        title: 'Προηγμένα Μοντέλα ΤΝ (GPT-4, Claude)',
        desc: 'Επιλέξτε από πρωτοποριακά μοντέλα τεχνητής νοημοσύνης για να συμφωνήσουν με τις απαιτήσεις μεταφρασής σας. Βεβαιωθείτε για βέλτιστα αποτελέσματα για διάφορους τύπους εγγράφων.',
      },
      grid1: {
        title: 'Υποστήριξη OCR',
        desc: 'Εξάγετε και μεταφράστε κείμενο από σαρωμένα PDF και εικόνες αμέσως.',
      },
      grid2: {
        title: 'Εξαγωγή Υψηλής Ανάλυσης',
        desc: 'Κατεβάστε τα μεταφρασμένα σας έγγραφα σε μορφή PDF με την πρωτότυπη διάταξη.',
      },
      grid3: {
        title: 'Σύγκριση Παράλληλα',
        desc: 'Συγχρονισμένη κύλιση για σύγκριση πρωτογενικού και μεταφρασμένου κειμένου.',
      },
      title1: 'Περισσότερο από απλά Μετάφραση',
      title2: 'Είναι μια Επανάσταση',
      line1: 'Τεχνικό Έγγραφο.pdf',
      line2: 'Αναίρεση γλώσσας: Αγγλικά...',
      line3: 'Μοντέλο: GPT-4o (Υψηλή Ακρίβεια)',
      line4: 'Μετάφραση Ολοκληρωμένη (Ακρίβεια 99%)',
    },
    testimonials: {
      review1: {
        role: 'Ερευνητής',
        content:
          'Το Noam AI με έσωσε ώρες στη μετάφραση ακαδημαϊκών εργασιών. Η προβολή πλευρά προς πλευρά είναι εξαιρετικά βοηθητική για τον έλεγχο τεχνικών όρων.',
      },
      review2: {
        role: 'Γლობალური Μάρκετερ',
        content:
          'Ο καλύτερος μεταφραστής PDF που έχω χρησιμοποιήσει. Διατηρεί την πρωτότυπη μορφοποίηση τέλεια, κάτι που είναι ζωτικής σημασίας για τα παρουσιασιακά μας φύλλα μάρκετινγκ.',
      },
      review3: {
        role: 'Νομικός Σύμβουλος',
        content:
          'Ακριβές και γρήγορο. Το χρησιμοποιώ για μεταφράσεις συμβολαίων και το χαρακτηριστικό OCR για σκανάρισμα εγγράφων λειτουργεί άψογα.',
      },
      kicker: 'Αγαπημένο από χρήστες',
      title: 'Τι Λένε Οι Χρήστες Μας',
    },
    cta: {
      title: 'Είστε έτοιμοι να σπάσετε τα γλωσσικά φραγμάτα;',
      desc: 'Εγγραφείτε μαζί με πάνω από 10.000 χρήστες και ξεκινήστε να μεταφράζετε τα έγγραφά σας με το Noam AI σήμερα.',
      button: 'Ξεκινήστε τη μετάφραση δωρεάν',
      hint: '',
    },
    languagePairs: {
      title: 'Ζεύγη Μεταφράσεων AI PDF Αγγλικά',
      desc: 'Δημοφιλή διευθύνσεις μετάφρασης που υποστηρίζονται από το Noam AI',
    },
    footer: {
      about: 'Σχετικά με εμάς',
      contact: 'Επικοινωνήστε με την Υποστήριξη',
      privacy: 'Πολιτική Προστασίας Προσωπικών Δεδομένων',
    },
  },
}

export default TRANSLATION
